(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileTransactionController', ProfileTransactionController);

    ProfileTransactionController.$inject = ['$scope', '$state', '$uibModal', 'entity', 'ProfileTransaction', 'ProfileTransfer', 'ProfileTkbCard', 'ProfileUniredPayment', 'ProfileUzbCards', 'ProfileTransactionAmount', 'ProfileTransferAmount', 'ParseLinks', 'AlertService', 'pagingParams', 'DateUtils', 'DataUtils', 'TkbTransfer', 'TkbPayment'];

    function ProfileTransactionController($scope, $state, $uibModal, entity, ProfileTransaction, ProfileTransfer, ProfileTkbCard, ProfileUniredPayment, ProfileUzbCards, ProfileTransactionAmount, ProfileTransferAmount, ParseLinks, AlertService, pagingParams, DateUtils, DataUtils, TkbTransfer, TkbPayment) {
        var vm = this;

        vm.profile = entity;
        vm.itemsPerPage = 20;
        vm.activeTab = pagingParams.activeTab;
        vm.activateTab = activateTab;

        vm.predicateTranHist = pagingParams.predicateTranHist;
        vm.reverseTranHist = pagingParams.ascendingTranHist;
        vm.transitionTranHist = transitionTranHist;
        vm.loadAllTranHist = loadAllTranHist;

        vm.predicateTransfer = pagingParams.predicateTransfer;
        vm.reverseTransfer = pagingParams.ascendingTransfer;
        vm.transitionTransfer = transitionTransfer;
        vm.loadAllTransfers = loadAllTransfers;

        vm.predicateTkbCard = pagingParams.predicateTkbCard;
        vm.reverseTkbCard = pagingParams.ascendingTkbCard;
        vm.transitionTkbCard = transitionTkbCard;
        vm.loadAllTkbCard = loadAllTkbCard;
        vm.predicateTkbPayment = pagingParams.predicateTkbPayment;
        vm.reverseTkbPayment = pagingParams.ascendingTkbPayment;
        vm.predicateUzbCards = pagingParams.predicateUzbCards;
        vm.reverseUzbCards = pagingParams.ascendingUzbCards;
        vm.transitionTkbPayment = transitionTkbPayment;
        vm.loadAllTkbPayment = loadAllTkbPayment;
        vm.loadAllUzbCards = loadAllUzbCards;
        vm.transitionUzbCards = transitionUzbCards;
        vm.dateDiff = DateUtils.transactionDateDifference;
        vm.getDirectAmount = DataUtils.getDirectAmount;
        vm.getSentAmount = DataUtils.getSentAmount;
        vm.getCurrencyNameForClient = DataUtils.getCurrencyNameForClient;
        vm.getCurrencySymbolForClient = DataUtils.getCurrencySymbolForClient;
        vm.checkList = [];
        vm.getTransferState = getTransferState;
        vm.confirmTransfer = confirmTransfer;
        vm.getPaymentState = getPaymentState;
        vm.confirmPayment = confirmPayment;
        vm.initPopover = initPopover;
        vm.initCreditPopover = initCreditPopover;
        vm.initPaymentPopover = initPaymentPopover;
        vm.initPaymentCreditPopover = initPaymentCreditPopover;
        vm.openTransferInfo = openTransferInfo;
        vm.openSenderCardDeleteModal = openSenderCardDeleteModal;
        vm.openPaymentInfo = openPaymentInfo;
        vm.openUzbCardEditModal = openUzbCardEditModal;

        loadAllTransfers();
        loadAllTranHist();
        loadAllTkbCard();
        loadAllTkbPayment();
        loadAllUzbCards();
        getTotalTransactionAmount();
        getTotalTransferAmount();

        function loadAllTranHist() {
            ProfileTransaction.query({
                profileId: vm.profile.id,
                page: pagingParams.pageTranHist - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc')];
                if (vm.predicateTranHist !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksTranHist = ParseLinks.parse(headers('link'));
                vm.totalItemsTranHist = headers('X-Total-Count');
                vm.queryCountTranHist = vm.totalItemsTranHist;
                vm.transactionHistories = data;
                vm.pageTranHist = pagingParams.pageTranHist;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionTranHist() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTranHist: vm.pageTranHist,
                sortTranHist: vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc'),
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbCard: vm.pageTkbCard,
                sortTkbCard: vm.predicateTkbCard + ',' + (vm.reverseTkbCard ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function loadAllTransfers() {
            ProfileTransfer.query({
                profileId: vm.profile.id,
                page: pagingParams.pageTransfer - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc')];
                if (vm.predicateTransfer !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksTransfer = ParseLinks.parse(headers('link'));
                vm.totalItemsTransfer = headers('X-Total-Count');
                vm.queryCountTransfer = vm.totalItemsTransfer;
                vm.transfers = data;
                vm.pageTransfer = pagingParams.pageTransfer;
                setTimeout(function () {
                    enableClipboard();
                }, 0);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionTransfer() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTranHist: vm.pageTranHist,
                sortTranHist: vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc'),
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbCard: vm.pageTkbCard,
                sortTkbCard: vm.predicateTkbCard + ',' + (vm.reverseTkbCard ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function loadAllTkbCard() {
            ProfileTkbCard.query({
                profileId: vm.profile.id,
                page: pagingParams.pageTkbCard - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateTkbCard + ',' + (vm.reverseTkbCard ? 'asc' : 'desc')];
                if (vm.predicateTkbCard !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksTkbCard = ParseLinks.parse(headers('link'));
                vm.totalItemsTkbCard = headers('X-Total-Count');
                vm.queryCountTkbCard = vm.totalItemsTkbCard;
                vm.tkbCards = data;
                vm.pageTkbCard = pagingParams.pageTkbCard;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionTkbCard() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTranHist: vm.pageTranHist,
                sortTranHist: vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc'),
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbCard: vm.pageTkbCard,
                sortTkbCard: vm.predicateTkbCard + ',' + (vm.reverseTkbCard ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function loadAllTkbPayment() {
            ProfileUniredPayment.query({
                profileId: vm.profile.id,
                page: pagingParams.pageTkbPayment - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateTkbPayment + ',' + (vm.reverseTkbPayment ? 'asc' : 'desc')];
                if (vm.predicateTkbPayment !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksTkbPayment = ParseLinks.parse(headers('link'));
                vm.totalItemsTkbPayment = headers('X-Total-Count');
                vm.queryCountTkbPayment = vm.totalItemsTkbPayment;
                vm.tkbPayments = data;
                vm.tkbPayments.forEach(function (payment) {
                    if (payment.fieldJson) {
                        var parsed = JSON.parse(payment.fieldJson);
                        payment.description = parsed.description;
                    }
                });
                vm.pageTkbPayment = pagingParams.pageTkbPayment;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionTkbPayment() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTranHist: vm.pageTranHist,
                sortTranHist: vm.predicateTranHist + ',' + (vm.reverseTranHist ? 'asc' : 'desc'),
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbPayment: vm.pageTkbPayment,
                sortTkbPayment: vm.predicateTkbPayment + ',' + (vm.reverseTkbPayment ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function loadAllUzbCards() {
            ProfileUzbCards.query({
                profileId: vm.profile.id,
                page: pagingParams.pageUzbCards - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicateUzbCards + ',' + (vm.reverseUzbCards ? 'asc' : 'desc')];
                if (vm.predicateUzbCards !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.linksUzbCards = ParseLinks.parse(headers('link'));
                vm.totalItemsUzbCards = headers('X-Total-Count');
                vm.queryCountUzbCards = vm.totalItemsUzbCards;
                vm.uzbCards = data;
                vm.pageUzbCards = pagingParams.pageUzbCards;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionUzbCards() {
            $state.transitionTo($state.$current, {
                id: vm.profile.id,
                pageTransfer: vm.pageTransfer,
                sortTransfer: vm.predicateTransfer + ',' + (vm.reverseTransfer ? 'asc' : 'desc'),
                pageTkbPayment: vm.pageTkbPayment,
                sortTkbPayment: vm.predicateTkbPayment + ',' + (vm.reverseTkbPayment ? 'asc' : 'desc'),
                pageUzbCards: vm.pageUzbCards,
                sortUzbCards: vm.predicateUzbCards + ',' + (vm.reverseUzbCards ? 'asc' : 'desc'),
                activeTab: vm.activeTab
            });
        }

        function activateTab(tab) {
            vm.activeTab = tab;
        }

        function getTotalTransactionAmount() {
            ProfileTransactionAmount.query({
                profileId: vm.profile.id
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalTransactionAmount = data.totalAmount;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getTotalTransferAmount() {
            ProfileTransferAmount.query({
                profileId: vm.profile.id
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalTransferAmount = data.totalTransferAmount;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getTransferState(externalId) {
            vm.checkList[externalId] = true;
            TkbTransfer.getTransferState({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function confirmTransfer(externalId) {
            vm.checkList[externalId] = true;
            TkbTransfer.confirmTransfer({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function getPaymentState(externalId) {
            vm.checkList[externalId] = true;
            TkbPayment.getPaymentState({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function confirmPayment(externalId) {
            vm.checkList[externalId] = true;
            TkbPayment.confirmPayment({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function enableClipboard() {
            var clipboardClass = document.getElementsByClassName('mt-clipboard');
            var clipboard = new Clipboard(clipboardClass);
        }

        function initPopover($event, transfer) {
            if (!transfer.message) {
                return;
            }
            var message = transfer.message;
            var elementId = transfer.id;

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + message + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function initCreditPopover($event, transfer) {
            if (!transfer.creditMessage) {
                return;
            }
            var creditMessage = transfer.creditMessage;
            var elementId = transfer.id + '-credit';

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + creditMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function initPaymentPopover($event, payment) {
            if (!payment.errorMessage) {
                return;
            }
            var errorMessage = payment.errorMessage;
            var elementId = payment.id;

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + errorMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function initPaymentCreditPopover($event, payment) {
            if (!payment.creditDescription) {
                return;
            }
            var creditMessage = payment.creditDescription;
            var elementId = payment.id + '-credit';

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + creditMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function copyPopoverText() {
            var textElement = document.getElementById('popover-text');
            if (!textElement) return;

            var textArea = document.createElement('textarea');
            textArea.value = textElement.innerText;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }

        function openTransferInfo(id) {
            var transfer = vm.transfers.find(function (item) {
                return item.id === id;
            });
            $uibModal.open({
                templateUrl: 'app/entities/tkb-transfer/tkb-transfer-info-dialog.html',
                controller: 'TkbTransferInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'tkb-payment-infopenTrao-dialog-xl',
                resolve: {
                    entity: transfer,
                    myID: ['MyID', function (MyID) {
                        if (transfer.myIDId) {
                            return MyID.get({id: transfer.myIDId}).$promise;
                        } else {
                            return null;
                        }
                    }],
                    customer: ['Customer', function (Customer) {
                        return Customer.get({id: transfer.userId}).$promise;
                    }]
                },

            });
        }

        function openSenderCardDeleteModal(cardId) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/tkb-card/tkb-card-delete-dialog.html',
                controller: 'TkbCardDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['TkbCard', function (TkbCard) {
                        return TkbCard.get({id: cardId}).$promise;
                    }]
                }
            });
            modalInstance.result.then(function () {
                if (cardId) {
                    var newCards = [];
                    angular.forEach(vm.tkbCards, function (card) {
                        if (card.id !== cardId) {
                            newCards.push(card);
                        }
                    });
                    vm.tkbCards = newCards;
                }
            });
        }

        function openPaymentInfo(id) {
            $uibModal.open({
                templateUrl: 'app/entities/tkb-payment/tkb-payment-info-dialog.html',
                controller: 'TkbPaymentInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'tkb-payment-info-dialog-xl',
                resolve: {
                    entity: ['TkbPayment', function(TkbPayment) {
                        return TkbPayment.paymentInfo({ paymentId: id }).$promise;
                    }]
                }
            });
        }

        function openUzbCardEditModal(id) {
            $uibModal.open({
                templateUrl: 'app/entities/uzb-card/uzb-card-dialog.html',
                controller: 'UzbCardDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['UzbCard', function(UzbCard) {
                        return UzbCard.get({ id: id }).$promise;
                    }]
                }
            }).result.then(function() {
                loadAllUzbCards();
            });
        }
    }
})();
